import { createSelector } from 'reselect';
import type { RootState } from '../index';
import type { Notification } from '../slices/uiSlice.ts';

// Base selector
const selectUIState = (state: RootState) => state.ui;

// Notification selectors
export const selectNotifications = createSelector([selectUIState], (ui) => ui?.notifications ?? []);

export const selectNotificationCount = createSelector(
  [selectNotifications],
  (notifications) => notifications.length,
);

export const selectNotificationsByType = (type: string) =>
  createSelector(
    [selectNotifications],
    (notifications) => notifications.filter((n: Notification) => n.type === type),
  );

export const selectLatestNotifications = (limit: number) =>
  createSelector([selectNotifications], (notifications) => notifications.slice(-limit));

// Modal selectors
export const selectModals = createSelector([selectUIState], (ui) => ui?.modals ?? []);

export const selectActiveModal = createSelector(
  [selectModals],
  (modals) => modals[modals.length - 1] ?? null,
);

export const selectHasModals = createSelector([selectModals], (modals) => modals.length > 0);

export const selectModalCount = createSelector([selectModals], (modals) => modals.length);
